import { Button, Card, Skeleton } from 'antd'
import React, { FC, useState } from 'react'
import { FCC } from 'types'
import fabImage from '../images/facebook.png'
import twilio from '../images/twilio.png'
import { TwilioData } from '../types'
import TwlIntergrationModal from './TwlIntergrationModal'

type IntegrationImgType = 'fb' | 'twl'

const getImge = (v: IntegrationImgType) => {
 switch (v) {
  case 'fb':
   return fabImage
  case 'twl':
   return twilio
  default:
   break
 }
}

const TwlIntegrationCard: FC<{
 isLoading?: boolean
 data?: TwilioData
 onConnect?: () => void
 content?: string
 type?: IntegrationImgType
}> = ({ type = 'fb', data, isLoading }) => {
 const [showModal, setShowModal] = useState(false)
 return (
  <>
   <Card className={`int-card-new int-card-new-${type}`}>
    {isLoading ? (
     <Skeleton />
    ) : (
     <>
      <div className="int-card-new-header">
       <img className="int-card-new-img" src={twilio} alt="" />
      </div>
      {data ? (
       <div className="twilio-list-blk">
        {data.phone_number && (
         <ItemBlk label="Twilio Phone" value={data.phone_number} />
        )}
        {data.twilio_account_id && (
         <ItemBlk label="Account SID" value={data.twilio_account_id} />
        )}
        <Button
         className="mt-2"
         onClick={() => setShowModal(true)}
         shape="round"
         type="link"
        >
         View All
        </Button>
       </div>
      ) : (
       <div className="text-center">
        <p>
         Seamlessly connect your Twilio account to AgentRoof CRM to send and
         receive SMS directly.
        </p>
        <Button onClick={() => setShowModal(true)} shape="round" type="primary">
         Connect Now
        </Button>
       </div>
      )}
     </>
    )}
   </Card>
   {showModal && (
    <TwlIntergrationModal
     data={data}
     //  intItems={intItems}
     //  setIntItems={setIntItems}
     onCancel={() => setShowModal(false)}
     show={showModal}
    />
   )}
  </>
 )
}

export default TwlIntegrationCard

const ItemBlk: FCC<{
 value?: string
 label?: string
}> = ({ label, value }) => {
 return (
  <div
   className="w-100 twilio-Item-blk"
   //  style={{
   //   display: 'flex',
   //   justifyContent: 'space-between',
   //   alignItems: 'center',
   //   border: '1px solid #aaa',
   //   padding: '2px 6px',
   //   borderRadius: '4px',
   //  }}
  >
   <div>{label} :</div>
   <div>
    <strong>{value}</strong>
   </div>
  </div>
 )
}
